import React, { useState } from "react";
import { Breadcrumb, Space, Divider, Tooltip } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import documentList from "../../img/documentList.svg";
import { getAccountFullName } from "../../lib/utils";
import { useAppSelector } from "../..";
import { Account } from "../../lib/interfaces";
import useBlockingMode from "../../lib/hooks/useBlockingMode";
import { getBlockingStatusIcon } from "../../lib/utils/getBlockingStatusIcon";
import BlockingModal from "../BlockingModal/BlockingModal";
import { BlockingObjTypes } from "../../lib/const/blockingObjTypes";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ACCOUNT_BILLS, MENU_ACCOUNT_BILLS_WRITE } from "../../lib/const/permissions";
import "./ProductHeader.less";

const styles = {
  billsButton: {
    boxShadow: "none",
    border: 0,
    marginBottom: "10px",
    outline: "none",
    cursor: "pointer",
  },
};

interface IProps {
  loadProductBlockingTypeStatus: () => void;
}

export const ProductHeader = ({ loadProductBlockingTypeStatus }: IProps) => {
  const { product } = useAppSelector((state) => state.products);
  const account = useAppSelector((state) => state.accounts.account) as Account;
  const history = useHistory();
  const { accountId } = useParams<{ accountId: string }>();

  const onClick = (e) => {
    e.stopPropagation();
    if (product?.id) {
      history.push(`/accounts/${account.id}/bills/search?serviceId=${product.id}`);
    }
  };

  const fullName = getAccountFullName(account);

  const accountName = account.individual
    ? [account.individual?.lastName, account.individual?.firstName, account.individual?.middleName]
        .filter(Boolean)
        .join(" ")
    : account.organization?.fullName;

  const { productBlockingStatus } = useAppSelector((state) => state.products);

  const isBlockingMode = useBlockingMode();

  const [objectBlockingId, setObjectBlockingId] = useState<{
    id?: number;
  }>({});

  const handleShowBlockingModal = (objId) => {
    setObjectBlockingId(objId);
  };

  const handleHideBlockingModal = () => {
    setObjectBlockingId({});
  };

  return (
    <div className="product-header">
      <Breadcrumb className="breadcrumb" style={{ backgroundColor: "white" }}>
        <Breadcrumb.Item>
          <Link to="/">Аккаунты</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/accounts/${account.id}/info`}>{fullName}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/accounts/${account.id}/products`}>Продукты</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Продукты на договоре</Breadcrumb.Item>
      </Breadcrumb>
      <div className="product-header__header">
        <h1 className="product-header__heading">{product?.serviceType.name}</h1>
        {hasAccess(MENU_ACCOUNT_BILLS, MENU_ACCOUNT_BILLS_WRITE) && (
          <Tooltip title="Показать счета по продукту">
            <button type="button" className="button-icon" onClick={onClick}>
              <img
                src={documentList}
                alt="documentList"
                width="24px"
                height="24px"
                style={styles.billsButton}
              />
            </button>
          </Tooltip>
        )}
        {isBlockingMode &&
          productBlockingStatus?.length > 0 &&
          productBlockingStatus[0] !== null && (
            <div style={{ marginRight: 5, marginTop: 8 }}>
              {getBlockingStatusIcon(productBlockingStatus[0], () =>
                handleShowBlockingModal({ id: product?.id })
              )}
            </div>
          )}

        <Space size="large" className="product-header__header_space">
          <Space>
            Аккаунт:
            <span className="product-header__property-value">{fullName}</span>
          </Space>
          <Space>
            Договор:
            <span className="product-header__property-value">
              {product?.agreement.agreementNumber}
            </span>
          </Space>
        </Space>
      </div>
      <Divider className="divider_thin" />
      <BlockingModal
        objectTypeId={BlockingObjTypes.Продукт}
        objectId={objectBlockingId?.id}
        handleHideModal={handleHideBlockingModal}
        visibleModal={!!objectBlockingId?.id}
        accountName={accountName}
        serviceAgreementId={product?.agreement?.id}
        agreementNumber={product?.agreement?.agreementNumber}
        serviceAgreementAccountId={product?.agreement?.accountId || accountId}
        serviceName={product?.serviceType?.name}
        dateObjectToForCalendar={product?.toDate}
        onSuccessRequest={loadProductBlockingTypeStatus}
      />
    </div>
  );
};
